import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';
import { UserService } from 'src/app/_services/generatedServices';
import { ReferralBonusViewModel } from 'src/app/_models/generatedModels';

@Component({
  selector: 'bxl-referrals',
  templateUrl: 'referrals.component.html'
})
export class ReferralsComponent implements OnInit {
  copiedVal = false;
  stats: ReferralBonusViewModel;
  initialized: boolean;
  constructor(public auth: AuthenticationService, public settings: SettingsProvider, public user: UserService) {}

  ngOnInit(): void {
    this.user.getReferralStats().subscribe(result => {
      this.stats = result;
      this.initialized = true;
    });
  }
  copied(event: any) {
    this.copiedVal = true;
    setTimeout(() => {
      this.copiedVal = false;
    }, 1000);
  }

  get url(): string {
    return this.settings.siteUrl + '?referral_token=' + this.auth.user.referralToken;
  }
}
